var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { generateReducer } from "../generators/generator.reducer";
import { getTaskCommentsStart, getTaskCommentsSucceeded, getTaskCommentsFailed, addTaskCommentStart, addTaskCommentSucceeded, addTaskCommentFailed, deleteTaskCommentStart, deleteTaskCommentSucceeded, deleteTaskCommentFailed, commentSetShowLimitStart, } from "./task.actions";
import { GENERATOR_PARAMS } from "./task.constants";
var getExtraDefaultState = function () { return ({
    comments: {},
    showLimit: 5,
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(getTaskCommentsStart.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { isFetching: true, fetchError: undefined }),
            _b) });
});
reducer.on(getTaskCommentsSucceeded.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId, refetch = _a.refetch, result = _a.result;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { isFetching: false, fetchError: undefined, items: result }),
            _b) });
});
reducer.on(getTaskCommentsFailed.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId, error = _a.error;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { isFetching: false, fetchError: error }),
            _b) });
});
reducer.on(addTaskCommentStart.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { isCreating: true, createError: undefined }),
            _b) });
});
reducer.on(addTaskCommentSucceeded.type, function (state, _a) {
    var _b;
    var _c, _d, _e;
    var taskId = _a.taskId, comment = _a.comment;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, (((_c = state === null || state === void 0 ? void 0 : state.comments) === null || _c === void 0 ? void 0 : _c[taskId]) || {})), { items: __spreadArray(__spreadArray([], (((_e = (_d = state === null || state === void 0 ? void 0 : state.comments) === null || _d === void 0 ? void 0 : _d[taskId]) === null || _e === void 0 ? void 0 : _e.items) || []), true), [comment], false), isCreating: false, createError: undefined }),
            _b) });
});
reducer.on(addTaskCommentFailed.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId, error = _a.error;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { isCreating: false, createError: error }),
            _b) });
});
reducer.on(deleteTaskCommentStart.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { isDeleting: true, deleteError: undefined }),
            _b) });
});
reducer.on(deleteTaskCommentSucceeded.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId, commentId = _a.commentId;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { items: (state.comments[taskId].items || []).filter(function (comment) { return comment.id !== commentId; }), isDeleting: false, deleteError: undefined }),
            _b) });
});
reducer.on(deleteTaskCommentFailed.type, function (state, _a) {
    var _b;
    var taskId = _a.taskId, error = _a.error;
    return __assign(__assign({}, state), { comments: (_b = {},
            _b[taskId] = __assign(__assign({}, state.comments[taskId]), { isDeleting: false, deleteError: error }),
            _b) });
});
reducer.on(commentSetShowLimitStart.type, function (state, _a) {
    var showLimit = _a.showLimit;
    return (__assign(__assign({}, state), { showLimit: showLimit }));
});
// eslint-disable-next-line import/no-default-export
export default reducer;
